document.addEventListener("DOMContentLoaded", function () {
    let a = !1;
    function b(b) {
        if (b && !a) {
                a = !0;
                let c;

                // There can be more than one link (a desktop one above the swatches and a
                // mobile one below them); update each so whichever is visible has a valid href.
                const colorSearchLinks = document.querySelectorAll("[data-color-search-link]");
                colorSearchLinks.forEach(function (colorSearchLink) {
                    const searchUrl = colorSearchLink.getAttribute("data-search-url") || "/search";
                    const code = b.toUpperCase();
                    // Field-scoped variants.sku:/variants.title: queries stopped matching the code token in Sept 2026; plain q still does.
                    colorSearchLink.href = searchUrl + "?q=" + encodeURIComponent(code) + "&type=product&search_by=color";
                    colorSearchLink.hidden = false;
                });

                const colorValuesElement = document.querySelector('[data-colors-list]');
                const colorValues = JSON.parse(colorValuesElement.textContent);
                c = colorValues[b.toUpperCase()];

                if (c) {
                    if (c) {
                        const coreElement = document.querySelector(".color-core span.core-color-title");
                        coreElement.innerHTML = c && c.trim() ? " " + c: "";
                    } else {
                        const limitedElement = document.querySelector(".color-limited span.limited-color-title");
                        limitedElement.innerHTML = c && c.trim() ? " " + c : "";
                    }
                } else {
                    const limitedElement = document.querySelector(".color-limited span.limited-color-title");
                    limitedElement.innerHTML = " ";
                }
                a = !1;
            }
    }

    window.firstVariant && window.firstVariant.option2 && b(window.firstVariant.option2.toLowerCase());
    function initViewersCount() {
        const viewersBlocks = document.querySelectorAll(".customer_view");
        if (!viewersBlocks.length) {
            return;
        }

        const viewersConfig = viewersBlocks[0].dataset;
        const viewersProductId = viewersConfig.productId;
        const viewersMax = Math.max(1, parseInt(viewersConfig.viewersMax, 10) || 10);
        const viewersMin = Math.min(viewersMax, Math.max(1, parseInt(viewersConfig.viewersMin, 10) || 1));
        const viewersUseAnalytics = viewersConfig.viewersSource === "analytics" && Boolean(viewersProductId);
        let viewersFilled = false;
        let viewersFallbackTimer = null;

        function randomViewersCount() {
            return viewersMin + Math.floor(Math.random() * (viewersMax - viewersMin + 1));
        }

        function setViewersCount(count) {
            viewersFilled = true;
            clearTimeout(viewersFallbackTimer);
            const shown = Math.round(count);
            viewersBlocks.forEach((block) => {
                const target = block.querySelector("[data-viewers-text]");
                const template = shown === 1 ? block.dataset.viewersTextOne : block.dataset.viewersTextMany;
                if (target && template) {
                    target.textContent = template.replace("[count]", shown);
                    block.removeAttribute("data-viewers-pending");
                }
            });
        }

        function fillViewersFallback() {
            if (!viewersFilled) {
                setViewersCount(randomViewersCount());
            }
        }

        if (!viewersUseAnalytics) {
            fillViewersFallback();
            return;
        }

        const viewersAbort = new AbortController();
        viewersFallbackTimer = setTimeout(() => {
            fillViewersFallback();
            viewersAbort.abort();
        }, 4000);
        fetch("https://webhooks.endrock.software/endrockapi/v3/app/analytics/reportsGA4.php?filterBy=productId&store=live_clothing&name=LIVE!%20USA%20-%20GA4&productId=" + viewersProductId, { signal: viewersAbort.signal })
            .then((response) => (response.ok ? response.json() : null))
            .then((payload) => {
                if (viewersFilled) {
                    return;
                }
                const viewed = Number(payload?.code === 200 ? payload?.data?.itemsViewed : NaN);
                if (Number.isFinite(viewed) && viewed > 0) {
                    setViewersCount(viewed);
                } else {
                    fillViewersFallback();
                }
            })
            .catch(fillViewersFallback);
    }

    initViewersCount();
    document.addEventListener("shopify:section:load", initViewersCount);

    window.addEventListener("scroll", function () {
        var a = window.pageYOffset || document.documentElement.scrollTop,
            b = document.querySelector(".scroller-container");
        200 < a ? b?.classList.add("fixed") : b?.classList.remove("fixed");
    }),
        document.body.addEventListener("click", function (a) {
            var c = a.target.closest(".option-color");
            if (!c) {
                return;
            }

            if (c.classList.contains("product-card-color-option")) {
                return;
            }

            var colorValue = c.getAttribute("data-color") || c.getAttribute("data-val");
            if (!colorValue) {
                return;
            }

            colorValue = colorValue.toLowerCase();
            document.querySelector(".color-" + colorValue)?.click();
            b(colorValue);
            document.querySelectorAll(".option-color").forEach((a) => a.classList.remove("active"));
            c.classList.add("active");
        });

    // Mega Menu Masonry Layout - DOM-based approach without absolute positioning
    (function() {
        const COLUMNS = 4;
        const BREAKPOINT = 1024;
        
        let resizeTimer = null;
        let observer = null;
        
        function getColumnHeights(columns) {
            return columns.map(col => col.offsetHeight);
        }
        
        function getShortestColumnIndex(columns) {
            const heights = getColumnHeights(columns);
            return heights.indexOf(Math.min(...heights));
        }
        
        function initMasonry(container) {
            if (window.innerWidth < BREAKPOINT) return;
            if (container.offsetWidth === 0) return;
            if (container.querySelector('.masonry-column')) return;
            
            const items = Array.from(container.querySelectorAll(':scope > li'));
            if (items.length === 0) return;
            
            // Create column containers
            const columns = [];
            const fragment = document.createDocumentFragment();
            
            for (let i = 0; i < COLUMNS; i++) {
                const column = document.createElement('div');
                column.className = 'masonry-column';
                columns.push(column);
                fragment.appendChild(column);
            }
            
            // Append columns first to measure heights
            container.appendChild(fragment);
            container.classList.add('masonry-ready');
            
            // Distribute items to shortest column
            items.forEach(item => {
                const shortestIndex = getShortestColumnIndex(columns);
                columns[shortestIndex].appendChild(item);
            });
        }
        
        function resetMasonry(container) {
            const columns = container.querySelectorAll('.masonry-column');
            if (columns.length === 0) return;
            
            const fragment = document.createDocumentFragment();
            
            // Collect all items in order
            columns.forEach(column => {
                const items = Array.from(column.children);
                items.forEach(item => fragment.appendChild(item));
            });
            
            // Remove columns
            columns.forEach(column => column.remove());
            container.classList.remove('masonry-ready');
            
            // Re-append items to container
            container.appendChild(fragment);
        }
        
        function processAllContainers() {
            const containers = document.querySelectorAll('.new-header .MenuDropdown .mega-menu-links-column-wrap');
            containers.forEach(container => {
                if (container.offsetWidth > 0) {
                    initMasonry(container);
                }
            });
        }
        
        function handleResize() {
            if (resizeTimer) clearTimeout(resizeTimer);
            
            resizeTimer = setTimeout(() => {
                const containers = document.querySelectorAll('.new-header .MenuDropdown .mega-menu-links-column-wrap');
                containers.forEach(container => {
                    resetMasonry(container);
                    if (window.innerWidth >= BREAKPOINT) {
                        initMasonry(container);
                    }
                });
                resizeTimer = null;
            }, 200);
        }
        
        function setup() {
            const header = document.querySelector('.new-header');
            if (!header) return;
            
            // Single MutationObserver for menu visibility changes
            observer = new MutationObserver((mutations) => {
                let shouldProcess = false;
                
                for (const mutation of mutations) {
                    if (mutation.type === 'attributes' && 
                        (mutation.attributeName === 'class' || mutation.attributeName === 'aria-hidden')) {
                        shouldProcess = true;
                        break;
                    }
                }
                
                if (shouldProcess) {
                    requestAnimationFrame(processAllContainers);
                }
            });
            
            const menuDropdowns = header.querySelectorAll('.MenuDropdown');
            menuDropdowns.forEach(dropdown => {
                observer.observe(dropdown, { 
                    attributes: true, 
                    attributeFilter: ['class', 'aria-hidden']
                });
            });
            
            // Single resize listener with debounce
            window.addEventListener('resize', handleResize, { passive: true });
            
            // Initial processing
            requestAnimationFrame(processAllContainers);
        }
        
        setup();
    })();

});

/* ------------------------------------------------------------
 * Shop This Look: intercept [lb-preview] clicks inside
 * #ShopThisLookSidebar and open the theme Quick Shop popup.
 *
 * The product handle is read from the closest ancestor with the
 * `lb-product-handle` attribute. We fetch /products/{handle}.js,
 * inject the `quick-add-product-data-{id}` JSON script the popup
 * expects, then trigger the popup via a synthetic click on a
 * hidden `.item-quick-add__button` (the existing document-level
 * click listener in quick-add-popup.js takes it from there).
 * ------------------------------------------------------------ */
(function () {
    'use strict';

    var productFetchCache = Object.create(null);

    function fetchProductJs(handle) {
        if (productFetchCache[handle]) return productFetchCache[handle];
        var p = fetch('/products/' + encodeURIComponent(handle) + '.js', {
            headers: { 'Accept': 'application/json' }
        }).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
        });
        productFetchCache[handle] = p;
        p.catch(function () { delete productFetchCache[handle]; });
        return p;
    }

    function ensureProductDataScript(product) {
        var id = 'quick-add-product-data-' + product.id;
        if (document.getElementById(id)) return;

        var selected = null;
        for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].available) { selected = product.variants[i]; break; }
        }
        if (!selected) selected = product.variants[0];

        var media = (product.media || []).map(function (m) {
            return {
                src: (m.preview_image && m.preview_image.src) || m.src || '',
                alt: m.alt || ''
            };
        });

        var inventory = product.variants.map(function (v) {
            return {
                id: v.id,
                inventory_quantity: typeof v.inventory_quantity === 'number' ? v.inventory_quantity : 0
            };
        });

        // quick-add-popup.js expects product.options to be an array of
        // strings (option names). /products/{handle}.js sometimes returns
        // them as objects ({name, values}) — normalize to strings here.
        var optionNames = (product.options || []).map(function (o) {
            if (typeof o === 'string') return o;
            if (o && typeof o.name === 'string') return o.name;
            return String(o);
        });

        var payload = {
            product: {
                id: product.id,
                handle: product.handle,
                title: product.title,
                price: product.price,
                options: optionNames,
                variants: product.variants,
                media: media
            },
            selected_or_first_available_variant: selected,
            variants_inventory: inventory
        };

        var script = document.createElement('script');
        script.type = 'application/json';
        script.id = id;
        script.textContent = JSON.stringify(payload);
        document.body.appendChild(script);
    }

    function openQuickShopForHandle(handle, loadingEl) {
        function clearLoading() {
            if (loadingEl && loadingEl.classList) loadingEl.classList.remove('loading');
        }

        function waitForPopupThenClear() {
            var popup = document.getElementById('quick-add-popup');
            if (!popup) { setTimeout(clearLoading, 600); return; }
            if (popup.classList.contains('_is-visible')) { clearLoading(); return; }
            var obs = new MutationObserver(function () {
                if (popup.classList.contains('_is-visible')) {
                    clearLoading();
                    obs.disconnect();
                }
            });
            obs.observe(popup, { attributes: true, attributeFilter: ['class'] });
            // Fallback: remove spinner after 5 s in case popup never opens.
            setTimeout(function () { obs.disconnect(); clearLoading(); }, 5000);
        }

        fetchProductJs(handle).then(function (product) {
            ensureProductDataScript(product);

            var fake = document.createElement('button');
            fake.className = 'item-quick-add__button';
            fake.setAttribute('data-product-id', String(product.id));
            fake.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
            document.body.appendChild(fake);

            // On the development branch the global `item-quick-add__button` click
            // listener was replaced by per-container listeners, so a synthetic
            // body-level click no longer reaches the popup init. Call it directly
            // when available; fall back to a synthetic click for older branches.
            var dispatched = false;
            try {
                if (typeof quickAddPopupInit === 'function') {
                    quickAddPopupInit(fake);
                    dispatched = true;
                }
            } catch (e) {}
            if (!dispatched) {
                try { fake.click(); } catch (e) {}
            }

            setTimeout(function () {
                if (fake.parentNode) fake.parentNode.removeChild(fake);
            }, 0);

            waitForPopupThenClear();
        }).catch(function (err) {
            clearLoading();
            if (window.console && console.warn) {
                console.warn('[quick-shop intercept]', err && err.message ? err.message : err);
            }
        });
    }

    function findInPath(path, attrName) {
        for (var i = 0; i < path.length; i++) {
            var node = path[i];
            if (node && node.nodeType === 1 && node.hasAttribute && node.hasAttribute(attrName)) {
                return node;
            }
        }
        return null;
    }

    // lb-preview intercept — scoped to #ShopThisLookSidebar when enabled via block setting.
    document.addEventListener('click', function (e) {
        if (!e) return;
        var sidebar = document.getElementById('ShopThisLookSidebar');
        if (!sidebar || sidebar.dataset.interceptLbPreview !== 'true') return;

        var path = (typeof e.composedPath === 'function') ? e.composedPath() : [];

        // Confirm the click originates inside the sidebar.
        var inSidebar = false;
        for (var s = 0; s < path.length; s++) {
            if (path[s] === sidebar) { inSidebar = true; break; }
        }
        if (!inSidebar && !sidebar.contains(e.target)) return;

        // Find [lb-preview="true"] in the composed path.
        var trigger = null;
        for (var i = 0; i < path.length; i++) {
            var node = path[i];
            if (node && node.nodeType === 1 && node.getAttribute && node.getAttribute('lb-preview') === 'true') {
                trigger = node; break;
            }
        }
        if (!trigger && e.target && e.target.closest) {
            trigger = e.target.closest('[lb-preview="true"]');
        }
        if (!trigger) return;

        var handleNode = findInPath(path, 'lb-product-handle');
        if (!handleNode && trigger.closest) {
            handleNode = trigger.closest('[lb-product-handle]');
        }
        var handle = handleNode ? handleNode.getAttribute('lb-product-handle') : null;
        if (!handle) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

        if (document.querySelector('.lb-button.loading')) return;
        var innerBtn = (trigger.querySelector) ? (trigger.querySelector('.lb-button') || trigger) : trigger;
        if (innerBtn.classList && innerBtn.classList.contains('loading')) return;
        if (innerBtn.classList) innerBtn.classList.add('loading');

        openQuickShopForHandle(handle, innerBtn);
    }, true);
})();
